/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryParams, StringParam } from 'use-query-params';

import { CollapsePanel, CollapsePanelGroup } from '@powdr/components';
import { ColorProfiles, QueryParamNames } from '@powdr/constants';
import { getViewAll } from '@powdr/stores';

import {
  CampBlock, CampButton,
  CampLeftWrapper, CampList, CampListItem,
  CampSubheader, CampTitle, Caption, ExternalLink, InnerWrapper, PanelTag, Photo,
  PhotoGrid, PhotoGridItem, PhotoGridTitle, PhotoGridWrapper,
  RatesDatesPanelInner, StyledRatesAndDatesGroup,
} from './styles';

const ratesDatesParams = {
  [QueryParamNames.ITEM]: StringParam,
};

export const RatesAndDatesGroup = ({
  data,
  panelTag = null,
}) => {
  const entityView = data?.entityView || null;
  const dispatch = useDispatch();
  const { drupal } = useSelector((state) => state.drupal) || [];
  const [viewData, setViewData] = useState([]);
  const [urlQueryParams] = useQueryParams(ratesDatesParams);

  useEffect(() => {
    dispatch(getViewAll(entityView?.viewMachineName));
  }, [dispatch, entityView?.viewMachineName]);

  useEffect(() => {
    if (drupal?.[entityView?.viewMachineName]) {
      setViewData(drupal[entityView?.viewMachineName]);
    }
  }, [drupal, entityView?.viewMachineName]);

  const createArray = (d) => ((Array.isArray(d)) ? d : [d]);

  if (!data || !entityView) return null;

  return (
    <StyledRatesAndDatesGroup>
      <CollapsePanelGroup parentColorProfile={ColorProfiles.BASE}>
        {viewData?.map((i, idx) => (
          <CollapsePanel
            panelColorProfile={ColorProfiles.QUATERNARY} // temporary
            cpHeader={{
              isContainer: false,
              title: i.field_display_title || i.title || null,
              subheader: i.field_subtitle || null,
              additionalLabel: i.field_availability || null,
            }}
            cpBody={{
              isContainer: false,
            }}
            openPanelOnLoad={(i.field_scroll_id
              && i.field_scroll_id === urlQueryParams?.[QueryParamNames.ITEM])}
            skipAnimation
            scrollToID={(i.field_scroll_id
              && i.field_scroll_id === urlQueryParams?.[QueryParamNames.ITEM])
              ? i.field_scroll_id
              : null}
          >
            <RatesDatesPanelInner
              $colorProfile={ColorProfiles.QUATERNARY} // temporary
            >
              {/* Panel Tag */}
              {(panelTag) && (<PanelTag>{panelTag}</PanelTag>)}

              <InnerWrapper>
                {/* Camp List */}
                {(viewData[idx]?.field_camps) && (
                <CampList>
                  {createArray(viewData[idx]?.field_camps)?.map((camp) => (
                    <CampListItem>
                      <CampBlock>
                        <CampLeftWrapper>
                          <CampTitle>{camp?.field_title}</CampTitle>
                          {(camp?.field_formatted_subheader?.value) && (
                          <CampSubheader>
                            {ReactHtmlParser(camp?.field_formatted_subheader?.value)}
                          </CampSubheader>
                          )}
                        </CampLeftWrapper>
                        <CampButton
                          $colorProfile={ColorProfiles.QUATERNARY}
                          href={camp?.field_button?.field_btn_href}
                        >
                          {camp?.field_button?.field_btn}
                        </CampButton>
                      </CampBlock>
                    </CampListItem>
                  ))}
                </CampList>
                )}

                {/* Pros */}
                {((viewData?.[idx]?.field_pros)) && (
                <PhotoGridWrapper>
                  {(viewData?.[idx]?.field_pro_section_title) && (
                    <PhotoGridTitle>
                      {ReactHtmlParser(viewData[idx]?.field_pro_section_title)}
                    </PhotoGridTitle>
                  )}
                  <PhotoGrid $count={createArray(viewData[idx].field_pros.length)}>
                    {createArray(viewData[idx].field_pros)?.map((item) => (
                      <PhotoGridItem>
                        <Photo
                          src={item.field_referenced_image?.default}
                          alt={item.field_referenced_image?.alt}
                        />
                        <Caption>{item.field_title}</Caption>
                      </PhotoGridItem>
                    ))}
                  </PhotoGrid>
                </PhotoGridWrapper>
                )}

                {/* Sponsors */}
                {(viewData[idx]?.field_sponsors) && (
                <PhotoGridWrapper>
                  {(viewData[idx]?.field_sponsor_section_title) && (
                  <PhotoGridTitle>
                    {ReactHtmlParser(viewData[idx]?.field_sponsor_section_title)}
                  </PhotoGridTitle>
                  )}
                  <PhotoGrid $count={createArray(viewData[idx].field_sponsors.length)}>
                    {createArray(viewData[idx].field_sponsors)?.map((item) => (
                      <PhotoGridItem>
                        <Photo
                          src={item.field_referenced_image?.default}
                          alt={item.field_referenced_image?.alt}
                        />
                        <Caption>{item.field_title}</Caption>
                      </PhotoGridItem>
                    ))}
                  </PhotoGrid>
                </PhotoGridWrapper>
                )}
              </InnerWrapper>

              {/* External Link */}
              {(viewData[idx]?.field_external_link) && (
                <ExternalLink
                  href={viewData[idx]?.field_external_link.field_btn_href}
                >
                  {viewData[idx]?.field_external_link.field_btn}
                </ExternalLink>
              )}

            </RatesDatesPanelInner>
          </CollapsePanel>
        ))}
      </CollapsePanelGroup>
    </StyledRatesAndDatesGroup>
  );
};

RatesAndDatesGroup.propTypes = {
  data: PropTypes.shape({
    entityView: PropTypes.shape({
      viewMachineName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  panelTag: PropTypes.string,
};
